import React, { useEffect, useState } from 'react';

import { Card, CardBody } from '../other/card/card';
import IPTVTopReportedDomains from './IPTVTopReportedDomains';
import IPTVTopReportedIsps from './IPTVTopReportedIsps';

const IPTVTopReportedStreamsMaintainers = () => {
  const [chartThemeKey, setChartThemeKey] = useState(0);

  useEffect(() => {
    const onThemeReload = () => setChartThemeKey(k => k + 1);
    document.addEventListener('theme-reload', onThemeReload);
    return () => document.removeEventListener('theme-reload', onThemeReload);
  }, []);

  return (
    <div className='row g-2 mt-1'>
      <div className='col-12'>
        <Card className='mb-0'>
          <CardBody className='relative p-0'>
            <div className='p-4'>
              <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
                <IPTVTopReportedDomains chartThemeKey={chartThemeKey} />
                <IPTVTopReportedIsps chartThemeKey={chartThemeKey} />
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default IPTVTopReportedStreamsMaintainers;
